import React, { FC } from "react";
import "./layout-app.less";
import { ReactComponent as WorkOutlined } from "themes/icons/work-o.svg";
import { ReactComponent as BookShelf } from "themes/icons/bookshelf.svg";
import { Link } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { RootState } from "app.store";
import _ from "lodash";
import { CurrentUser } from "states/account/account.models";
import { setLogoutUser } from "states/account/account.action";
import { logout } from "states/account/account.api";
type AsideComponentProps = {
  currentUser: CurrentUser | any;
};

const AsideComponent: FC<AsideComponentProps> = (props) => {
  const { currentUser } = props;
  const dispatch = useDispatch();
  const activeMenu = useSelector(
    (state: RootState) => state.appSetting.activatedMenu,
    shallowEqual
  );
  const activedMenu = (key: string) => {
    return activeMenu === key ? `active` : "";
  };

  return !_.isEmpty(currentUser) ? (
    <aside id="account-menu">
      <div className="section-header">
        <div className="avatar">
          <span>{currentUser.name?.charAt(0)}</span>
        </div>
        <div className="des">
          <div className="t-1">Tài khoản</div>
          <div className="username text-bold">{currentUser?.name}</div>
        </div>
      </div>
      <div className="section-body">
        <ul>
          <li className={activedMenu("profile")}>
            <Link to="/account/profile">
              <span className="icon ecs-user" />
              <span>Thông tin tài khoản</span>
            </Link>
          </li>
          <li className={activedMenu("address")}>
            <Link to="/account/addresses">
            <span className="icon ecs-location" />
              <span>Quản lí địa chỉ</span>
            </Link>
          </li>
          <li className={activedMenu("order")}>
            <Link to="/account/orders">
            <span className="icon ecs-shopping-cart-2" />
              <span>Theo dõi đơn hàng</span>
            </Link>
          </li>
          <li>
            <button
              onClick={() => {
                logout();
                dispatch(setLogoutUser());
              }}
            >
                <span className="icon ecs-logout" />
              <span>Đăng xuất</span>
            </button>
          </li>
        </ul>
      </div>
    </aside>
  ) : null;
};

export default AsideComponent;
